import React, { useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { DynamicTag, AlertBox, PageActionPlaceHolder } from 'msp-components'
import { useWishlist, useNavigation } from 'msp-integrations'
import LineItemProduct from '@/components/organisms/LineItemProduct/LineItemProduct'
import { AlertType } from './AccountWishlist.types'

const AccountWishlistNoItems = ({
  ctaActionCB
}: {
  ctaActionCB: () => void
}) => {
  const { formatMessage } = useIntl()

  return (
    <PageActionPlaceHolder
      iconName='WishlistAdd'
      heading={formatMessage({
        defaultMessage: `You don't have any item in your wishlist.`,
        id: 'msp.account.wishlist.placeholder.no_item_heading'
      })}
      text={formatMessage({
        defaultMessage:
          'Continue shopping by clicking on the add button below.',
        id: 'msp.account.wishlist.placeholder.text'
      })}
      buttonText={formatMessage({
        defaultMessage: 'Continue Shopping',
        id: 'msp.account.wishlist.placeholder.cta_text'
      })}
      onButtonClick={ctaActionCB}
    />
  )
}

const AccountWishlist = () => {
  const { formatMessage } = useIntl()
  const wishlist = useWishlist()
  const navigate = useNavigation()
  const alertBoxRef = useRef<AlertBox>()
  const [alertBoxMessage, setAlertBoxMessage] = useState<AlertType>({
    type: 'error',
    message: ''
  })

  const onShowAlert = (alert: AlertType) => {
    setAlertBoxMessage(alert)
    alertBoxRef?.current?.showAlert()
  }

  return (
    <div>
      <AlertBox
        ref={alertBoxRef}
        type={alertBoxMessage.type}
        title={alertBoxMessage.message}
        autoCloseTime={2000}
        position='bottom'
        showBackdrop={false}
      />
      <DynamicTag
        componentTagName='Headline'
        tag='h6'
        className={'font-Roboto mb-4'}
      >
        {formatMessage(
          {
            id: 'msp.account.wishlist.title',
            defaultMessage: 'My Wishlist ({count} items)'
          },
          { count: wishlist.items.length }
        )}
      </DynamicTag>
      {wishlist.isEmpty ? (
        <AccountWishlistNoItems ctaActionCB={() => navigate('/shop')} />
      ) : (
        <div className='-mx-3 md:mx-0'>
          {wishlist.items?.map((item) => (
            <LineItemProduct
              key={item.productId || item.id}
              productId={item.productId}
              type='XS'
              isWishlistPage
              onWishlistChange={onShowAlert}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default AccountWishlist
